<ts-dialog title="Associate Company" (closeDialog)="discard()">
  <main ts-dialog-body class="flex flex-col flex-1 w-full">
    <form [formGroup]="companyForm">
      <!-- Company Name Control -->
      <div class="flex flex-col gt-xs:flex-row">
        <mat-form-field class="flex-auto">
          <mat-label>Company Name</mat-label>
          <input matInput [formControlName]="'name'" [placeholder]="'Company Name'" [spellcheck]="false" />
        </mat-form-field>
      </div>

      <ng-container>
        <!-- Company Website Control -->
        <div class="flex flex-col gt-xs:flex-row">
          <mat-form-field class="flex-auto">
            <mat-label>Website</mat-label>
            <input matInput [formControlName]="'website'" [placeholder]="'Website'" />
          </mat-form-field>
        </div>

        <!-- Company Address Control -->
        <div class="flex flex-col gt-xs:flex-row">
          <ng-container>
            <fieldset class="w-full" [formGroupName]="'address'">
              <mat-form-field class="flex-auto w-full">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  google-place
                  [placeholder]="'Address'"
                  [formControlName]="'address_string'"
                  (onSelect)="setAddress($event)"
                  (onSelectParts)="onSelectAddressParts($event)"
                  autocomplete="none"
                />
              </mat-form-field>
            </fieldset>
          </ng-container>
        </div>

        <!-- Company Tags Control -->
        <div class="flex flex-col gt-xs:flex-row">
          <ng-container>
            <mat-form-field class="flex-auto">
              <mat-label>Tags</mat-label>
              <mat-chip-list #chipList aria-label="Tag selection">
                <mat-chip
                  *ngFor="let tag of tags | keyvalue"
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeTag(tag.value)"
                >
                  {{ tag.value }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input
                  placeholder="New tag..."
                  #tagsInput
                  [matAutocomplete]="auto"
                  [formControlName]="'tagsInput'"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addTag($event)"
                  (focus)="tagsInput.focused = true"
                  (blur)="tagsInput.focused = false"
                  data-cy="tags-input"
                />
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTag($event)">
                <ng-container *ngIf="tagsSearchResult$ | async as tagsSearchResult">
                  <mat-option *ngFor="let tag of tagsSearchResult | keyvalue" [value]="tag.key">
                    {{ tag.key }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
              <mat-hint *ngIf="tagsInput.focused" class="mt-2">
                Press <strong>TAB</strong> key after finishing typing to add a new tag
              </mat-hint>
            </mat-form-field>
          </ng-container>
        </div>
      </ng-container>
    </form>
  </main>

  <div ts-dialog-actions>
    <ng-container>
      <button class="mr-auto reset-button" mat-stroked-button type="button" (click)="resetForm()">
        <span>Clear</span>
      </button>
    </ng-container>
    <button class="discard-button" mat-button type="button" (click)="discard()">
      <span>Cancel</span>
    </button>
    <button
      class="send-button"
      mat-flat-button
      [color]="'primary'"
      [disabled]="isSaveBtnDisabled"
      DebounceClick
      (debounceLoading)="isDebounceLoading($event)"
      (debounceClick)="saveCompanyAssociation()"
    >
      <span *ngIf="!isLoading; else LoadingSpinner"> Create and Save </span>
    </button>
  </div>
</ts-dialog>

<ng-template #LoadingSpinner>
  <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
</ng-template>
